import { createAction } from '@reduxjs/toolkit';

import type {
  EndpointId,
  EndpointRequest,
} from '@iconik-io/iconik-api/src/client/request';
import type { EndpointError } from '@iconik-io/iconik-api/src/client/response';

const HTTP_REQUEST_NETWORK_ERROR = 'HTTP_REQUEST_NETWORK_ERROR';
const HTTP_CANCEL_REQUESTS = 'HTTP_CANCEL_REQUESTS';

// Both type parameters are required: with only the payload parameter given,
// the action type widens to string and breaks RootAction narrowing.
export const httpRequestNetworkError = createAction<
  EndpointError,
  typeof HTTP_REQUEST_NETWORK_ERROR
>(HTTP_REQUEST_NETWORK_ERROR);

export const httpCancelRequests = createAction<
  EndpointId[],
  typeof HTTP_CANCEL_REQUESTS
>(HTTP_CANCEL_REQUESTS);

export const cancellable = <Request extends EndpointRequest>(
  request: Request,
  cancelKey?: string,
): Request => ({
  ...request,
  meta: {
    ...request.meta,
    cancellable: true,
    cancelKey,
  },
});

export const skipRedirectOnLogin = <Request extends EndpointRequest>(
  request: Request,
): Request => ({
  ...request,
  meta: {
    ...request.meta,
    skipLoginRedirect: true,
  },
});

export const skipNormalizer = <Request extends EndpointRequest>(
  request: Request,
): Request => ({
  ...request,
  meta: {
    ...request.meta,
    skipNormalizer: true,
  },
});
